import { render, staticRenderFns } from "./BInputGroupFormSelect.vue?vue&type=template&id=22bf864e&"
import script from "./BInputGroupFormSelect.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22bf864e')) {
      api.createRecord('22bf864e', component.options)
    } else {
      api.reload('22bf864e', component.options)
    }
    module.hot.accept("./BInputGroupFormSelect.vue?vue&type=template&id=22bf864e&", function () {
      api.rerender('22bf864e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/forms/BInputGroupFormSelect.vue"
export default component.exports